export * from './home.component';

